export const COMPANY_TABS = [
    { value: "projects", label: "Proyectos" },
    { value: "vault", label: "Bóveda" },
];
